<template>
  <div>
    <el-config-provider :locale="locale">
      <router-view></router-view>
    </el-config-provider>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
export default defineComponent({
  components: {
    ElConfigProvider
  },
  setup() {
    return {
      locale: zhCn
    }
  }
})
</script>
<style>
body {
  background: #ededed;
  min-width: 1080px;
}
/* 页面滚动条样式修改 */
.windows-system ::-webkit-scrollbar-track-piece {
  background-color: transparent !important;
}
.windows-system ::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}
.windows-system ::-webkit-scrollbar-thumb {
  background-color: #c2c2c2;
  background-clip: padding-box;
  min-height: 28px;
}
@media (-webkit-max-device-pixel-ratio: 1) {
  ::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    background-clip: padding-box;
    min-height: 28px;
  }
  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
}

@media screen and (max-width: 1440px) {
  .long_num_font {
    font-size: 12px !important;
  } /*当屏幕小于1440px时，改变长数字大小*/
}
</style>
